import Vue from 'vue'
import Vuex from 'vuex'
import {userService} from '@/api/user-service'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    GroupList: null,
    userProfile: '',
  },
  mutations: {
    GET_USERPROFILE(state, result) {
      state.userProfile = result
    },
    GET_GROUP_LIST(state, result)
    {
      state.GroupList = result;
    }
  },
  actions: {
    async getGroupList({commit})
    {
      let result = await userService.getGroupList();
      commit('GET_GROUP_LIST',result);
    },
    async getUserProfile({commit}){
      let result = await userService.getUserProfile();
      commit('GET_USERPROFILE', result);
    },
  },
  getters:{
    userProfile: state => state.userProfile,
    groupList: state=>state.GroupList
  },
  modules: {
  }
})
